import { useReactiveVar } from "@apollo/client";
import { Tabs, TabsProps } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

import Spinner from "../../../components/layout/spinner/Spinner";
import NoPermission from "../../../components/others/NoPermission";
import { Colors } from "../../../constants/Colors";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { __currentUser__ } from "../../../graphql/policies";
import { ServiceTypes } from "../../../types/types";
import { renderDecodedId } from "../../../utils/renderDecodedId";
import { PerformersType, VideoOptionsType, VideoType } from "./content/faceCallTypes";
import PerformersTabContent from "./performersTabContent";
import { fetchFaceCallPerformers, fetchFaceCallVideos, fetchFaceCallVideoOptions } from "./services/faceCall.services";
import SongsTabContent from "./songsTabContent";
import VideosTabContent from "./videosTabContent";
import "./faceCall.scss";

interface ServiceBannerAndIconProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}

const ZippyFaceCall = ({
  setSelectedService,
  setSelectSubItem,
}: ServiceBannerAndIconProps) => {
  const currentUser = useReactiveVar(__currentUser__);
  const [loading, setLoading] = useState<boolean>(true);
  const [videosData, setVideosData] = useState<VideoType[]>([]);
  const [videoOptions, setVideoOptions] = useState<VideoOptionsType | undefined>();
  const [performersData, setPerformersData] = useState<PerformersType[]>([]);
  const [activeKey, setActiveKey] = useState("1");
  const [selectPerformers, setSelectPerformers] = useState<string[] | null>(null);
  const isAdmin = currentUser?.isAdministrator || false;

  const {
    data: userPrograms,
    loading: userProgramsLoading,
  } = useGetUserProgramsByServiceQuery({
    variables: {
      userId: parseInt(renderDecodedId(currentUser?.id)),
      serviceId: 10,
    },
  });

  const refreshData = async () => {

    fetchFaceCallVideos().then(res => {
      if (res?.data) setVideosData(res.data);
    });

    fetchFaceCallVideoOptions().then(res => {
      if (res?.data) setVideoOptions(res.data);
    });

    fetchFaceCallPerformers().then(res => {
      if (res?.data) setPerformersData(res.data);
    }).finally(() => setLoading(false));
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Videos",
      children: <VideosTabContent
        videosData={videosData}
        videoOptions={videoOptions}
        selectPerformers={selectPerformers}
        setSelectPerformers={setSelectPerformers}
        isAdmin={isAdmin}
        refreshData={refreshData}
      />,
    },
    {
      key: "2",
      label: "Songs",
      children: <SongsTabContent />,
    },
    {
      key: "3",
      label: "Performers",
      children: <PerformersTabContent
        performersData={performersData}
        setActiveKey={setActiveKey}
        setSelectPerformers={setSelectPerformers}
        isAdmin={isAdmin}
        refreshData={refreshData} />,
    },
  ];

  const onChange = (key: string) => {
    setActiveKey(key);
  };

  useEffect(() => {
    setSelectedService(ServiceTypes.ZIPPY_AND_ME);
    setSelectSubItem("Zippy Face Call");
    refreshData();
  }, []);

  if (userProgramsLoading || loading) return <Spinner />;

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "Zippy Face Call"
    )
  ) return <NoPermission />;


  return (
    <div id="faceCallWrapper">
      <div className="header" style={{ backgroundColor: Colors.white }}>
        <p className="header-title" style={{ color: Colors.darkGrey }}>
          Face Call
        </p>
      </div>
      <Tabs
        activeKey={activeKey}
        items={items}
        size="small"
        onChange={onChange}
        tabBarStyle={{
          paddingLeft: 24,
          backgroundColor: Colors.white,
          height: 50,
        }}
      />
    </div>
  );
};

export default ZippyFaceCall;
